module.exports = __webpack_public_path__ + "static/media/Doc-Browser-Light-Bigger.df5e710a.svg";